import { Component, OnInit, Inject, AfterViewInit } from '@angular/core';
import { ItemMaster } from '../../../shared/models/item.master.interface';
import { ItemType, ItemCoverageType, ItemCoverageTypes } from '../../../shared/models/item.type.interface';
import { RValue } from '../../../shared/models/r.value.interface';
import { Vendor } from '../../../shared/models/vendor.interface';
import { Warehouse } from '../../../shared/models/warehouse.interface';
import { AdminService } from '../../services/admin.service';
import { NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { ItemUsage } from '../../../shared/models/item.usage.interface';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ItemDialogData } from '../item-list/item-list.component';

export interface ItemCoverageData {
  item_ID: number;
  itemUsages: ItemUsage[];
  coveragePerSet: number;
  columnEntries: number;
}

@Component({
  selector: 'app-item-edit',
  templateUrl: './item-edit.component.html',
  styleUrls: ['./item-edit.component.scss']
})

export class ItemEditComponent implements OnInit {
  coverageEnum = ItemCoverageType;
  item: ItemMaster;
  itemTypes: ItemType[];
  itemTypesFiltered: ItemType[];

  itemTypeCoverage: ItemCoverageTypes;

  rValues: RValue[];
  vendors: Vendor[];
  warehouses: Warehouse[];
  itemUsages: ItemUsage[] = [];
  itemType: ItemType;
  itemCoverageData: ItemCoverageData;
  canDeleteItem: boolean = false;
  showItemCoverage: boolean = false;
  showBlow: boolean = false;
  showSpray: boolean = false;
  showAeroBarrier: boolean = false;
  itemTypeRequired: boolean = true;
  isIDIAdmin: boolean = false;
  isItemPartReadOnly = true;

  isRequesting: boolean;
  errors: string;

  constructor(private adminService: AdminService, public itemDialogRef: MatDialogRef<ItemEditComponent>, @Inject(MAT_DIALOG_DATA) public data: ItemDialogData) { }

  ngOnInit() {
    let itemId: string = this.data.id;
    let dealerId = this.adminService.getDealerId();
    this.rValues = this.data.rValues;

    this.isIDIAdmin = (AdminService._authNavStatusSource.value == 'IDI');

    if (itemId == null) {
      this.item = {} as ItemMaster;
      this.item.item_isActive = true;
      this.isItemPartReadOnly = false;
    }
    else {
      this.adminService.getItem(itemId)
        .subscribe({
          next: (data) => {
            this.item = data;
            this.itemTypeRequired = !data.itemType?.itemType_IsAccessory;
            this.showAeroBarrier = data.itemType.itemCoverageType_ID == this.coverageEnum.AeroBarrier;
            this.isItemPartReadOnly = !this.isIDIAdmin && this.item?.item_IDIPart !== null || (!this.item === undefined);

            if (data.itemType?.itemType_IsUsage) {
              this.showItemCoverage = data.itemType.itemType_IsUsage;
              this.itemCoverages();
            }

            //if (this.item.itemType.itemType_IsActive) {
            //  this.itemTypesFiltered = this.itemTypes.filter(d => d.itemCoverageType_ID != this.coverageEnum.AeroBarrier && d.itemType_IsActive);
            //}
            //else {
            //  this.itemTypesFiltered = this.itemTypes.filter(d => d.itemCoverageType_ID != this.coverageEnum.AeroBarrier &&
            //    (d.itemType_IsActive));
            //}
          }
        })

      this.adminService.checkCanDeleteItem(itemId)
        .subscribe({
          next: (data) => {
            this.canDeleteItem = data;
          }
        })
    }

    this.adminService.getItemTypes(dealerId)
      .subscribe({
        next: (data) => {
          this.itemTypes = data;          
          this.itemTypesFiltered = data.filter(d => d.itemCoverageType_ID != this.coverageEnum.AeroBarrier && d.itemType_IsActive);         
        }
      });

    this.adminService.getVendorsList(dealerId)
      .subscribe({
        next: (data) => {
          this.vendors = data;
        }
      });

    this.adminService.getWarehouseList(dealerId)
      .subscribe({
        next: (data) => {
          this.warehouses = data;
        }
      });
  }

  saveItem(form: NgForm) {

    console.log('in item onSubmit: ', this.item)
    this.errors = '';

    if (form.valid) {
      this.isRequesting = true;

      if (this.item.item_ID == null) {
        this.item.dealer_ID = this.adminService.getDealerId();
        this.item.itemType = null;
      }

      this.adminService.saveItem(this.item)
        .pipe(finalize(() => this.isRequesting = false))
        .subscribe({
          next: (result) => {
            if (result) {
              if (this.itemCoverageData != null) {
                this.adminService.saveItemCoverages(result, this.itemCoverageData?.itemUsages)
                  .subscribe({
                    next: (result) => {
                      if (result) {
                        this.itemDialogRef.close();
                      }
                    },
                    error: (error: string) => {
                      this.errors = error;
                    }
                  });
              }

              this.itemDialogRef.close();
            }
          },
          error: (error: string) => { this.errors = error; }
        })
    };
  }

  calculateCostUnit() {
    if (this.item.item_SqrFtPerUnit && this.item.item_Cost_SqrFt) {
      this.item.item_Cost = this.item.item_SqrFtPerUnit * this.item.item_Cost_SqrFt;

      this.item.item_Cost = Math.round(this.item.item_Cost * 100000) / 100000;
    }
  }

  calculateCostSqFt() {
    if (this.item.item_SqrFtPerUnit && this.item.item_Cost) {
      this.item.item_Cost_SqrFt = (this.item.item_Cost / this.item.item_SqrFtPerUnit);

      this.item.item_Cost_SqrFt = Math.round(this.item.item_Cost_SqrFt * 100000) / 100000;
    }
  }

  calculateCost() {
    if (this.item.item_Cost_SqrFt && this.item.item_Cost) {
      this.item.item_Cost = this.item.item_Cost_SqrFt;
    }
  }

  deleteItem(itemId) {
    var proceed = confirm($localize`Are you sure?`);
    if (!proceed) return;

    console.log('in item delete: ', this.item)
    this.errors = '';
    if (itemId != null) {
      this.adminService.deleteItem(itemId)
        .pipe(finalize(() => this.isRequesting = false))
        .subscribe({
          next: (result) => {
            if (result) {
              this.itemDialogRef.close();
            }
          },
          error: (error: string) => {
            this.errors = error;
          }
        });
    }
  }

  onItemTypeChange(itemTypeId: number) {
    this.adminService.getItemType(itemTypeId)
      .subscribe({
        next: (data) => {
          this.item.itemType = data;
          if (data.itemType_IsUsage) {
            this.showItemCoverage = data.itemType_IsUsage;
            this.itemCoverages();
            this.showBlow = data.itemCoverageType_ID == ItemCoverageType.Blow;
            this.showSpray = data.itemCoverageType_ID == ItemCoverageType.Inches;
            this.showAeroBarrier = false;
            this.itemTypeRequired = !data.itemType_IsAccessory;
          }
          else if (data.itemCoverageType_ID == ItemCoverageType.AeroBarrier) {
            this.showItemCoverage = false;
            this.itemCoverageData = null;
            this.itemUsages = null;
            this.showBlow = false;
            this.showSpray = false;
            this.showAeroBarrier = data.itemCoverageType_ID == ItemCoverageType.AeroBarrier;
            this.itemTypeRequired = !data.itemType_IsAccessory;
          }
          else {
            this.showItemCoverage = false;
            this.itemCoverageData = null;
            this.itemUsages = null;
            this.showBlow = false;
            this.showSpray = false;
            this.showAeroBarrier = false;
            this.itemTypeRequired = !data.itemType_IsAccessory;
          }
        }
      });
  }

  itemCoverages() {
    let selectedrValues = this.buildRValueData();
    this.itemUsages = [];

    for (let rValue of selectedrValues.sort(s => s.rValue_Sort)) {
      let iu = this.item.itemUsages?.find(iu => iu.rValue_ID == rValue.rValue_ID);
      if (iu != null && iu.itemUsage_ID != null) {
        this.itemUsages.push(iu);
      }
      else {
        let itemUsage = {} as ItemUsage;
        itemUsage.itemUsage_ID = null;
        itemUsage.item_ID = this.item.item_ID
        itemUsage.rValue_ID = rValue.rValue_ID;
        itemUsage.itemUsage_SqrFtg = null;
        itemUsage.rValue = rValue;

        this.itemUsages.push(itemUsage);
      }
    }

    this.itemCoverageData = {
      item_ID: this.item.item_ID,
      itemUsages: this.itemUsages,
      coveragePerSet: this.getCoveragePerSet(),
      columnEntries: this.itemUsages.length % 3 > 0 ? (Math.round(this.itemUsages.length / 3)) + 1 : (this.itemUsages.length / 3),
    } as ItemCoverageData;
  }

  getCoveragePerSet() {
    if (this.item?.itemType?.itemCoverageType_ID == ItemCoverageType.Inches) {
      var itemInches = this.itemUsages.find(iu => iu.rValue_ID == 23);
      if (itemInches != null)
        return itemInches.itemUsage_SqrFtg;
      else
        return 0;

    };
  }

  buildRValueData() {
    let selectedrValues: RValue[];
    if (this.item?.itemType?.itemCoverageType_ID == ItemCoverageType.Blow) {
      selectedrValues = this.rValues.filter(r => r.rValue_Desc.startsWith("R-"));
    }
    else {
      selectedrValues = this.rValues.filter(r => !r.rValue_Desc.startsWith("R-"));
    }

    return selectedrValues;
  }

  onNoClick(): void {
    this.itemDialogRef.close();
  }

  calcItemCoverages(data: ItemCoverageData) {
    for (let iu of data.itemUsages) {
      iu.rValue.rValue_Desc = iu.rValue.rValue_Desc.replace('"', '');
      iu.itemUsage_SqrFtg = +(data.coveragePerSet / +iu.rValue.rValue_Desc).toFixed(2);
      iu.rValue.rValue_Desc = iu.rValue.rValue_Desc + '"';
    }
  }
}
